import { fromJS } from "immutable";
import { barcodeQtyImportActions } from "actions/barcodeQtyImportActions.js";

const initialState = fromJS({
  hasErrors: false,
  isUploadSuccesful: false,
  importJob: {
    event_log_id: null,
    job_id: null,
    status: null,
    stage: null,
    total_rows: null,
    processed_rows: null,
    progress_percentage: null,
    error_message: null,
    redirect_url: null,
    completed_at: null
  },
  data: {
    presignedUrl: null
  }
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case barcodeQtyImportActions.fileUploadUrlSuccess:
      return state
        .merge({
          hasErrors: false
        })
        .set("data", fromJS(payload.data));
    case barcodeQtyImportActions.fileUploadUrlFailure:
      return state
        .merge({
          hasErrors: true
        })
    case barcodeQtyImportActions.buyplanBarcodeQtyImportRequest:
      return state
        .merge({
          hasErrors: false,
          isUploadSuccesful: false
        })
        .mergeIn(["importJob"], fromJS({
          event_log_id: null,
          job_id: null,
          status: "processing",
          stage: "retrieving_file",
          total_rows: null,
          processed_rows: 0,
          progress_percentage: 0,
          error_message: null,
          redirect_url: null,
          completed_at: null
        }));
    case barcodeQtyImportActions.buyplanBarcodeQtyImportSuccess:
      return state
        .merge({
          isUploadSuccesful: true
        })
        .mergeIn(["importJob"], fromJS({
          event_log_id: payload?.data?.event_log_id ?? null,
          job_id: payload?.data?.job_id ?? null
        }));
    case barcodeQtyImportActions.buyplanBarcodeQtyImportFailure:
      return state
        .merge({
          hasErrors: true
        })
        .mergeIn(["importJob"], fromJS({
          status: "failed",
          error_message: payload?.data?.errors?.[0] ?? payload?.data?.message ?? null
        }));
    case barcodeQtyImportActions.barcodeQtyImportStatusSuccess:
      return state
        .mergeIn(["importJob"], fromJS(payload?.data || {}));
    case barcodeQtyImportActions.barcodeQtyImportStatusFailure:
      return state
        .merge({
          hasErrors: true
        });
    case barcodeQtyImportActions.barcodeQtyImportCompleted:
      return state
        .mergeIn(["importJob"], fromJS({
          ...(payload?.data || {}),
          completed_at: Date.now()
        }));
    case barcodeQtyImportActions.barcodeQtyImportReset:
      return initialState;
    default:
      return state;
  }
};

